import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { formatNumber } from "../Utils/utils";
import {
  updateDataForPdf,
  updateBtnPdf,
} from "../Store/secureInvestmentIncome/actions";
import { decryptEstandar } from "../Utils/CryptographyUtils";
import { plansValues } from '../Utils/constants'

const TableRG = ({ items }) => {
  const data = useSelector((state) => state.cotizador.valuesPdf);
  const dispatch = useDispatch();
  let nrDoc = items && items[0] ? decryptEstandar(items[0].typeDoc) === "2" ? "DNI :" : decryptEstandar(items[0].typeDoc) === "3" ? "PASAPORTE:" : "CARNET EXT. :" : "";
  let number = items && items[0] ? decryptEstandar(items[0].nroDoc) : "";

  const handleOnChange = (e) => {
    const { name } = e.target;
    const arrayName = name.split("_");
    const position = arrayName[1];
    const newData = data;

    newData[position].active = !newData[position].active;
    const activeBtn = newData.some((x) => x.active === true);
    dispatch(updateDataForPdf(newData));
    dispatch(updateBtnPdf(activeBtn));
  };

  return (
    <div className="md-g-wapper__container__table">
      <div className="title">COTIZACIONES</div>
      <div className="numdoc">
        {nrDoc} <span>{number}</span>
      </div>
      <div className="table-container">
        <table align="center" className="tablenew">
          <thead>
            <tr>
              <th
                data-field="id"
                className="md-g-wapper__container__table__item"
              >
                Plan
              </th>
              <th
                data-field="name"
                className="md-g-wapper__container__table__item"
              >
                Moneda
              </th>
              <th
                data-field="price"
                className="md-g-wapper__container__table__item"
              >
                Prima
              </th>
              <th
                data-field="price"
                className="md-g-wapper__container__table__item"
              >
                Temporalidad
              </th>
              <th
                data-field="price"
                className="md-g-wapper__container__table__item"
              >
                Ajuste
              </th>
              <th
                data-field="price"
                className="md-g-wapper__container__table__item"
              >
                Pensión
              </th>
              <th
                data-field="price"
                className="md-g-wapper__container__table__item"
              >
                T.V.
              </th>
              <th
                data-field="checkbox"
                className="md-g-wapper__container__table__item"
              >
                Seleccione las simulaciones a descargar
              </th>
            </tr>
          </thead>
          <tbody>
            {items.map((value, key) => {
              return (
                <tr key={key}>
                  <td className="md-g-wapper__container__table__item">
                    {plansValues[value.planes]}
                  </td>
                  <td className="md-g-wapper__container__table__item">
                    {value.money_rg}
                  </td>
                  <td className="md-g-wapper__container__table__item">
                    {value.capital}
                  </td>
                  <td className="md-g-wapper__container__table__item">
                    {value.temporalYears}
                  </td>
                  <td className="md-g-wapper__container__table__item">
                    {value.ajuste_pension === "true" ? "Si" : "No"}
                  </td>
                  <td className="md-g-wapper__container__table__item">
                    {formatNumber.new(parseFloat(value.pension))}
                  </td>
                  <td className="md-g-wapper__container__table__item">
                    {value.tv}%
                  </td>
                  <td className="md-g-wapper__container__table__item">
                    <label>
                      <input
                        name={`checkbox_${key}`}
                        className="filled-in"
                        type="checkbox"
                        defaultChecked={value.active}
                        onChange={(e) => handleOnChange(e)}
                      />
                      <span className="checkbox-name"></span>
                    </label>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};
export default TableRG;
